// Movimiento como apoyo visual: contenido visible y navegación siempre normal.
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  let observer;
  let interactions;
  const frames = new Map();
  const arrivals = new Map();

  function targets() {
    return [...new Set(document.querySelectorAll(
      '[data-rv], [data-motion], .idea-card, .story-bubble, main section, .site-footer'
    ))];
  }

  function enter(element, delay = 0, animate = false) {
    const firstEntry = !element.classList.contains('is-in');
    if (firstEntry && animate) {
      element.style.setProperty('--entrance-delay', `${delay}ms`);
      if (element.matches('.testi-stage')) {
        const viewport = element.querySelector('.testi-viewport').getBoundingClientRect();
        const slide = [...element.querySelectorAll('.testi-slide')].find(item => {
          const bounds = item.getBoundingClientRect();
          return bounds.right > viewport.left + 1 && bounds.left < viewport.right - 1;
        });
        slide?.classList.add('motion-slide');
      }
      element.classList.add('motion-arriving');
      arrivals.set(element, setTimeout(() => {
        element.classList.remove('motion-arriving');
        arrivals.delete(element);
      }, 1000));
    }
    element.classList.add('in', 'is-in');
    if (element.matches('section, .site-footer')) element.classList.add('has-entered');
  }

  function enterBatch(entries) {
    const groups = new Map();
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const element = entry.target;
      let group;
      if (element.matches('.idea-card, .story-bubble')) group = element.parentElement;
      else if (element.matches('.step-visual')) group = element.closest('.steps');
      const index = group ? groups.get(group) || 0 : 0;
      if (group) groups.set(group, index + 1);
      enter(element, Math.min(index * 55, 160), true);
      observer.unobserve(element);
    });
  }

  function clearTilt(card) {
    const frame = frames.get(card);
    if (frame) cancelAnimationFrame(frame);
    frames.delete(card);
    card.style.removeProperty('--tilt-x');
    card.style.removeProperty('--tilt-y');
    card.style.removeProperty('--mx');
    card.style.removeProperty('--my');
  }

  function updateMotion() {
    observer?.disconnect();
    interactions?.abort();
    document.querySelectorAll('.idea-card').forEach(clearTilt);
    document.body.classList.toggle('motion-enabled', !reducedMotion.matches);
    const elements = targets();
    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      arrivals.forEach((timer, element) => {
        clearTimeout(timer);
        element.classList.remove('motion-arriving');
      });
      arrivals.clear();
      elements.forEach(element => enter(element));
      return;
    }

    observer = new IntersectionObserver(enterBatch, {
      threshold: 0.14,
      rootMargin: '0px 0px -4% 0px'
    });
    elements.forEach(element => {
      if (!element.classList.contains('is-in')) observer.observe(element);
    });

    if (!finePointer.matches) return;
    interactions = new AbortController();
    document.querySelectorAll('.idea-card').forEach(card => {
      card.addEventListener('pointermove', event => {
        if (frames.has(card)) return;
        const x = event.clientX;
        const y = event.clientY;
        frames.set(card, requestAnimationFrame(() => {
          frames.delete(card);
          const bounds = card.getBoundingClientRect();
          const relativeX = Math.max(0, Math.min(1, (x - bounds.left) / bounds.width));
          const relativeY = Math.max(0, Math.min(1, (y - bounds.top) / bounds.height));
          card.style.setProperty('--tilt-x', `${(0.5 - relativeY) * 5}deg`);
          card.style.setProperty('--tilt-y', `${(relativeX - 0.5) * 5}deg`);
          card.style.setProperty('--mx', `${x - bounds.left}px`);
          card.style.setProperty('--my', `${y - bounds.top}px`);
        }));
      }, { signal: interactions.signal });
      card.addEventListener('pointerleave', () => clearTilt(card), { signal: interactions.signal });
      card.addEventListener('pointercancel', () => clearTilt(card), { signal: interactions.signal });
    });
  }

  function init() {
    updateMotion();
    reducedMotion.addEventListener('change', updateMotion);
    finePointer.addEventListener('change', updateMotion);
    // «Ver más» revela tarjetas ya presentes en el DOM; se observan al aparecer.
    document.querySelectorAll('.recipient-more').forEach(button => {
      button.addEventListener('click', () => {
        if (reducedMotion.matches) return;
        document.querySelectorAll('.idea-card:not([hidden])').forEach(card => {
          if (!card.classList.contains('is-in')) observer?.observe(card);
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
